import { Injectable } from '@angular/core'
import { ApplicationConversationDMConfigProvider, ConversationTypes } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class CandidateApplicationConversationDMProvider extends ApplicationConversationDMConfigProvider {
  conversationType = ConversationTypes.JobApplicationDM
}
